// A pallet number on the inspection page that opens the pallet, stamped so the
// pallet page's Back returns here — to the same view (UF-04). The inspection
// page had no way out to a pallet at all (flowmap: 0 outbound links).
//
// A viewer who may not open pallets gets the number as plain text: a link the
// route would refuse bounces them to Home.
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import PalletIdText from '@/components/PalletIdText'
import { useReturnHereState } from '@/lib/returnTo'

export default function PalletLink({ id, canOpen, className }: {
  id:        string
  canOpen:   boolean
  /** Colour / weight classes for the number. */
  className?: string
}) {
  const here = useReturnHereState()
  if (!canOpen) return <PalletIdText id={id} className={className} />
  return (
    <Link to={`/pallets/${id}`} state={here} title={`Open pallet ${id}`}
      className={clsx('inline-flex items-center min-h-[44px] -my-3 min-w-0 max-w-full hover:underline underline-offset-2', className)}>
      <PalletIdText id={id} />
    </Link>
  )
}
